export * from './baThemePreloader.service';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/services/baThemePreloader/index.ts